/* Stylesheet */

.chart_wrapper {
  padding: 32px;
  margin: 4px;
  background: var(--ion-gradient-light);
  box-shadow: var(--ion-box-shadow);
  border-radius: 8px;

  .flex_container {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .actions {
      display: flex;
      align-items: center;
      gap: 4px;
    }
  }

  .download_button {
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    color: var(--ion-color-medium, #92949c);
    font-size: 20px;
    line-height: 1;
    transition: color 0.2s ease, opacity 0.2s ease;

    &:hover:not(:disabled) {
      color: var(--ion-color-primary, #3880ff);
    }

    &.download_button_loading {
      opacity: 0.4;
      cursor: wait;
    }
  }
}

.resizer {
  display: flex;
  justify-content: flex-end;

  .icon {
    height: 21px;
    width: 21px;
    cursor: ns-resize;
  }
}
